import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const stats = [
  { value: "€3M+" },
  { value: "18+" },
  { value: "+29%" },
  { value: "2019" },
];

export const Manifesto = () => {
  const { t } = useLang();
  const chapters = [
    { num: "01", testid: "manifesto-chapter-1", title: t("man_ch1_t"), text: t("man_ch1_x") },
    { num: "02", testid: "manifesto-chapter-2", title: t("man_ch2_t"), text: t("man_ch2_x") },
  ];
  const statLabels = t("stats");

  return (
    <section id="approccio" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
      <Reveal>
        <p className="text-xs tracking-[0.35em] uppercase font-mono text-amber-400/90 mb-4">{t("man_overline")}</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-zinc-100 max-w-2xl">
          {t("man_h1")} <span className="italic text-gold">{t("man_h2")}</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 mt-16 lg:mt-24">
        {chapters.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.15}>
            <div data-testid={c.testid} className="border-t border-amber-500/15 pt-8">
              <span className="font-mono text-sm text-[#D4AF37] tracking-[0.3em]">{c.num}</span>
              <h3 className="font-display text-2xl sm:text-3xl font-semibold text-zinc-100 mt-4 mb-5">{c.title}</h3>
              <p className="text-sm sm:text-base text-zinc-400 leading-relaxed">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-16 lg:mt-24">
        <div id="numeri" data-testid="manifesto-chapter-3" className="border-t border-amber-500/15 pt-10">
          <span className="font-mono text-sm text-[#D4AF37] tracking-[0.3em]">{t("man_ch3")}</span>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
            {stats.map((s, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <div className="group">
                  <p className="font-display text-4xl sm:text-5xl lg:text-6xl text-zinc-100 group-hover:text-gold transition-colors duration-500">
                    {s.value}
                  </p>
                  <p className="text-xs tracking-[0.22em] uppercase text-zinc-500 mt-3">{statLabels[i]}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
